angular.module('impactx.oci').controller('OCIConfirmationCtrl', OCIConfirmationCtrl);

OCIConfirmationCtrl.$inject = ['$scope', 'dataGen', '$mdDialog', 'catalog', 'themeFactory', 'TranslationService', '$config'];

function OCIConfirmationCtrl($scope, dataGen, $mdDialog, catalog, themeFactory, TranslationService, $config)
{
    var ctrl = this;
    
    $scope.catalog = catalog;
    $scope.theme = themeFactory.getTheme();
    $scope.forwardLabel = TranslationService.get('forward');
    $scope.abortLabel = TranslationService.get('abort');

    dataGen.getData($scope, {id: catalog.id}, "/oci/confirmation/view");

    ctrl.answer = function(){
        window.location.href = $config.baseURL + "/oci/ocipage.jsp?CAT.Id=" + catalog.id + "&impactX=true";
        $mdDialog.hide();
    };

    ctrl.cancel = function(){
        $mdDialog.cancel();
    };
}